<template>
  <div class="password-strength-container">
    <div
      class="strength-item"
      :class="{ passwordSuccess: passwordStrength >= 25 }"
    ></div>
    <div
      class="strength-item"
      :class="{ passwordSuccess: passwordStrength >= 50 }"
    ></div>
    <div
      class="strength-item"
      :class="{ passwordSuccess: passwordStrength >= 75 }"
    ></div>
    <div
      class="strength-item"
      :class="{ passwordSuccess: passwordStrength >= 100 }"
    ></div>
  </div>
</template>

<script>
import { passwordStrengthCalculator } from "../../utils/index";
export default {
  props: {
    password: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      passwordStrength: 0
    };
  },
  methods: {
    checkPasswordStrength(password) {
      this.passwordStrength = passwordStrengthCalculator(password);
    }
  },
  watch: {
    password() {
      this.checkPasswordStrength(this.password);
    }
  }
};
</script>

<style lang="scss" scoped>
.password-strength-container {
  display: flex;
  justify-content: space-between;
  .strength-item {
    background-color: #c4c4c4;
    height: 4px;
    border-radius: 5px;
    width: 60px;
  }

  .passwordSuccess {
    background-color: rgb(26, 199, 26);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resuables/password-strength.vue